import {
  OverrideIndicators,
  overrideIndicatorsDefaults,
  WidgetLayoutSettings,
} from '@neptune/shared/widgets-domain';

import { countSectionOverrides, hasConflictWithDefaultSettings } from './layout-utils';

type Props = {
  globalLayoutSettings?: WidgetLayoutSettings;
  widgetLayoutSettings?: WidgetLayoutSettings[];
};

export const getGlobalLayoutOverrideIndicators = ({
  globalLayoutSettings,
  widgetLayoutSettings = [],
}: Props): OverrideIndicators => {
  if (!globalLayoutSettings) {
    return overrideIndicatorsDefaults;
  }

  const conflictWithDefaultSettings = hasConflictWithDefaultSettings(globalLayoutSettings);

  const settingOverrideInSectionsCount = conflictWithDefaultSettings
    ? countSectionOverrides({ globalLayoutSettings, widgetLayoutSettings })
    : 0;

  return {
    ...overrideIndicatorsDefaults,
    showMainIndicator: conflictWithDefaultSettings,
    settingOverrideInSectionsCount,
    mainIndicatorColor: settingOverrideInSectionsCount === 0 ? 'info' : 'warning',
  };
};
